<template>
  <!-- Profile -->
  <div class="w3-card w3-round w3-white">
    <div class="w3-container">
      <h4 v-if="currUser" class="w3-center">{{currUser.name}}</h4>
  <!--
      <p class="w3-center"><img src="../../assets/w3images/avatar3.png" class="w3-circle" style="height:106px;width:106px" alt="Avatar"></p>
      <hr>
      <p><i class="fa fa-pencil fa-fw w3-margin-right w3-text-theme"></i> Designer, UI</p>
      <p><i class="fa fa-home fa-fw w3-margin-right w3-text-theme"></i> London, UK</p>
      <p><i class="fa fa-birthday-cake fa-fw w3-margin-right w3-text-theme"></i> April 1, 1988</p>
  -->
    </div>
  </div>
    
</template>

<script>
  import ProfileSection from './ProfileSection.ts'
  export default ProfileSection
</script>
